import React from 'react';
import { useTranslation } from 'react-i18next';
import CONSTANTS from '@components-shared/constants';
import { KeyMapKeys } from '@locales/lokalise/keyMap';

interface ISelectorCreateButton {
  changeStepHandle: (state: string) => void;
  name: string;
}

export const SelectorCreateButton = (props: ISelectorCreateButton): JSX.Element => {
  const { i18n } = useTranslation();
  const { name, changeStepHandle } = props;
  const onClickButton = () => {
    changeStepHandle(CONSTANTS.PSP_WIZARD_STEP.ACCOUNT_STATEMENT_FORM);
  };

  return (
    <button type="button" className="link-btn" onClick={onClickButton}>
      + {i18n.t(name as KeyMapKeys)}
    </button>
  );
};
